import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import api from '@/axios';
import { GET_PRODUCTION_DECLARATION_MATERIALS_KEY } from '@/keys';
import type { ProductionDeclarationMaterial } from '@/types/core/purchase-order/production-declaration-material';

async function getProductionDeclarationMaterials(
  productionDeclarationId: string,
  options?: { token?: string },
): Promise<ProductionDeclarationMaterial[]> {
  const response = await api.get<ProductionDeclarationMaterial[]>(
    `/production-declarations/${productionDeclarationId}/materials`,
    {
      params: options?.token ? { token: options.token } : undefined,
    },
  );

  return response.data;
}

export function useGetProductionDeclarationMaterials(
  productionDeclarationId: string,
  token: string | undefined,
): UseQueryResult<ProductionDeclarationMaterial[], Error> {
  return useQuery({
    queryKey: [
      ...GET_PRODUCTION_DECLARATION_MATERIALS_KEY,
      productionDeclarationId,
      token ?? '',
    ],
    queryFn: async () =>
      await getProductionDeclarationMaterials(productionDeclarationId, {
        token,
      }),
    enabled: Boolean(productionDeclarationId),
  });
}
